import React from "react";
import { Drawer as AntdDrawer } from "antd";

export function Drawer({
  title,
  open,
  footer,
  onclose,
  width,
  body,
  placement,
  classname,
}) {
  return (
    <div className={classname}>
      <AntdDrawer
        title={title}
        placement={placement || "right"}
        onClose={onclose}
        open={open}
        footer={footer || null}
        width={width || 700}
      >
        <div className="col_1 p_20">{body}</div>
      </AntdDrawer>
    </div>
  );
}
